/**
 * Maps API return messages that will trigger a pNotify notification
 */

export const IMPERSONATING_ON = {
    compiled_message: 'Impersonation successfully started.',
    subject: 'Impersionation on',
};

export const IMPERSONATING_OFF = {
    compiled_message: 'Impersonation successfully stopped.',
    subject: 'Impersionation off',
};
